export default function noop() {
  // noop
}
